import { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Button from './Button';
import styles from './Header.module.css';

// Навигационные ссылки (конфигурация)
const NAV_LINKS = [
  { to: '/', label: 'Главная' },
  { to: '/philosophy', label: 'Философия и методики' },
  { to: '/team', label: 'Спикеры' },
  { to: '/club', label: 'Клуб' },
];

// Ссылки только для авторизованных
const AUTH_NAV_LINKS = [
  { to: '/news', label: 'Новости' },
  { to: '/recommendations', label: 'Рекомендации' },
];

const Header = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  // Флаг появления тени при скролле
  const [isScrolled, setIsScrolled] = useState(false);
  // Флаг мобильного меню
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Отслеживаем скролл для добавления тени
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsMenuOpen(false);
  };

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
      <div className={`container ${styles.inner}`}>
        {/* Логотип */}
        <Link to="/" className={styles.logo} onClick={closeMenu}>
          <span className={styles.logoAccent}>Терушкин</span>
          <span className={styles.logoSuffix}>&nbsp;ОС</span>
        </Link>

        {/* Навигация (десктоп) */}
        <nav className={`${styles.nav} ${isMenuOpen ? styles.navOpen : ''}`}>
          {NAV_LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
              }
              onClick={closeMenu}
            >
              {label}
            </NavLink>
          ))}
          {isAuthenticated && AUTH_NAV_LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
              }
              onClick={closeMenu}
            >
              {label}
            </NavLink>
          ))}

          {/* Кнопка авторизации (мобильная версия) */}
          <div className={styles.navActions}>
            {isAuthenticated ? (
              <>
                <NavLink
                  to="/profile"
                  className={({ isActive }) =>
                    `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
                  }
                  onClick={closeMenu}
                >
                  Личный кабинет
                </NavLink>
                <Button variant="outline" size="sm" onClick={handleLogout}>
                  Выйти
                </Button>
              </>
            ) : (
              <Button
                variant="secondary"
                size="sm"
                onClick={() => {
                  navigate('/login');
                  closeMenu();
                }}
              >
                Войти
              </Button>
            )}
          </div>
        </nav>

        {/* Кнопки авторизации (десктоп) */}
        <div className={styles.desktopActions}>
          {isAuthenticated ? (
            <>
              <NavLink
                to="/profile"
                className={({ isActive }) =>
                  `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
                }
              >
                Личный кабинет
              </NavLink>
              <Button variant="outline" size="sm" onClick={handleLogout}>
                Выйти
              </Button>
            </>
          ) : (
            <Button variant="secondary" size="sm" onClick={() => navigate('/login')}>
              Войти
            </Button>
          )}
        </div>

        {/* Кнопка бургер-меню (мобильная) */}
        <button
          className={`${styles.burger} ${isMenuOpen ? styles.burgerOpen : ''}`}
          onClick={() => setIsMenuOpen((prev) => !prev)}
          aria-label="Открыть меню"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

export default Header;
